<ngx-simplebar style="height: 100%" class="scrollbar">
    <div class="card-padding">
        <mat-card class="card">
            <h1>Vertrag anlegen</h1>
            <form [formGroup]="ContractForm" (ngSubmit)="Submit()">
                <app-textfield Key="Name" [Value]="Name" [Required]="true"></app-textfield>
                <app-textfield Key="Nummer" [Value]="Number" [Required]="true"></app-textfield>
                <app-textfield Key="Vertragsnummer" [Value]="VertragsNummer"></app-textfield>
                <app-textfield Key="Vertragskennzeichen" [Value]="ContractSign"></app-textfield>
                <app-chip-autocomplete
                    [formControl]="ContractGroupType"
                    [MapFn]="MapContractGroupType"
                    [Options]="ContractGroupTypeList | async"
                    [Disabled]="ContractGroupType.value.length === 1"
                    Placeholder="Vertragsgruppe"
                ></app-chip-autocomplete>

                <app-textarea Key="Beschreibung" [Value]="Description"></app-textarea>
                <div class="date-time-picker">
                    <app-datepicker
                        Key="Startdatum"
                        [Value]="StartDate.value"
                        (Input)="OnStartDateChange($event.value)"
                        [Required]="false"
                    ></app-datepicker>
                </div>
                <div class="date-time-picker">
                    <app-datepicker
                        Key="EndDate"
                        [Value]="EndDate.value"
                        (Input)="OnEndDateChange($event.value)"
                        [Required]="false"
                        [Min]="StartDate.value"
                        [Max]="null"
                    ></app-datepicker>
                </div>
                <mat-form-field>
                    <mat-select placeholder="Vertragsstatus" [formControl]="ContractStatus">
                        <mat-option *ngFor="let option of ContractStatusList | async" [value]="option">{{
                            option.Name
                        }}</mat-option>
                    </mat-select>
                </mat-form-field>
                <app-textfield Key="Abrechnungszyklus" [Value]="Abrechnungszyklus"></app-textfield>
                <app-textfield Key="DTA Optionen" [Value]="DTAOptions"></app-textfield>
                <app-textfield Key="Fallnummer" [Value]="Casenumber"></app-textfield>
                <mat-form-field class="type">
                    <mat-select placeholder="hat Anamnese" [formControl]="HatAnamnese">
                        <mat-option [value]="true">Ja</mat-option>
                        <mat-option [value]="false">Nein</mat-option>
                    </mat-select>
                </mat-form-field>
                <mat-form-field class="type">
                    <mat-select placeholder="ist WKV" [formControl]="IstWKV">
                        <mat-option [value]="true">Ja</mat-option>
                        <mat-option [value]="false">Nein</mat-option>
                    </mat-select>
                </mat-form-field>
                <app-textfield Key="Widerrufsfrist in Tagen" [Value]="WiderrufsfristInTagen"></app-textfield>
                <app-textfield Key="Kündigungsfrist in Tagen" [Value]="KuendigungsfristInTagen"></app-textfield>
                <app-textfield Key="Laufzeit in Monaten" [Value]="LaufzeitInMonaten"></app-textfield>
                <app-textfield
                    Key="Einreichfrist nach Quartalende in Wochen"
                    [Value]="EinreichfristNachQuartalEndeInWochen"
                ></app-textfield>
                <app-textfield Key="mindestalter Versicherter" [Value]="MindestalterVersicherter"></app-textfield>
                <app-textfield Key="TE Gueltikeit Dauer" [Value]="TeGueltigkeitDauerValue"></app-textfield>
                <mat-form-field class="type">
                    <mat-select placeholder="TE Gueltikeit Dauer Einheit" [formControl]="TeGueltigkeitDauerUnit">
                        <mat-option *ngFor="let option of TEGueltigkeitDauerUnits" [value]="option.value">{{
                            option.multiple
                        }}</mat-option>
                    </mat-select>
                </mat-form-field>
                <br />
                <mat-form-field class="type">
                    <mat-select placeholder="TE Gueltigkeit" [formControl]="TEGueltigkeit">
                        <mat-option *ngFor="let option of TEGueltigkeitList | async" [value]="option">{{
                            option.Name
                        }}</mat-option>
                    </mat-select>
                </mat-form-field>
                <app-textfield Key="TE anzahl Seiten" [Value]="TEAnzahlSeiten"></app-textfield>
                <mat-form-field class="type">
                    <mat-select
                        placeholder="Medizinprodukte Eigenleistung erlaubt"
                        [formControl]="MedizinprodukteEigenleistungErlaubt"
                    >
                        <mat-option [value]="true">Ja</mat-option>
                        <mat-option [value]="false">Nein</mat-option>
                    </mat-select>
                </mat-form-field>
                <app-textfield Key="Sachkonto Debitor" [Value]="SachkontoDebitor"></app-textfield>
                <app-textfield Key="Sachkonto Kreditor" [Value]="SachkontoKreditor"></app-textfield>
                <mat-form-field class="type">
                    <mat-select
                        placeholder="Hat Diagnostik"
                        [formControl]="ContractForm.controls.HatDiagnostik"
                    >
                        <mat-option [value]="true">Ja</mat-option>
                        <mat-option [value]="false">Nein</mat-option>
                    </mat-select>
                </mat-form-field>
                <div class="buttons">
                    <div class="cancel-button-wrapper">
                        <button app-button (click)="Cancel()" type="button" class="button">Abbrechen</button>
                    </div>
                    <button app-button [Disabled]="ContractForm.invalid" class="button">Anlegen</button>
                </div>
            </form>
        </mat-card>
    </div>
</ngx-simplebar>
